/* NY2K Maison motion for inner pages (11 Oct 2026). Vanilla, no dependencies.
   Loaded by snippets/mx-motion.liquid. Tags content itself, so no section
   needs editing. See that snippet for what it covers and how to revert. */
(function(){
'use strict';
if(window.mxmReady)return;
var d=document,r=d.documentElement;
function done(){window.mxmReady=1;r.classList.remove('mxm-pre');}
function off(){r.classList.remove('mxm');done();}
if(!r.classList.contains('mxm')){done();return;}
var M=d.getElementById('MainContent');
if(!M||!('IntersectionObserver' in window)){off();return;}

var vh=window.innerHeight||800;
var OWN='.mxc,.ny2kc,.fbl-hero';
var SKIP=OWN+',.mxm-words,.fbl-reveal-item,.fbl-mask,.fbl-process-step,.fbl-credential,.fbl-marquee,script,style,template,noscript,link,svg,br,option,source,[hidden]';
if(r.classList.contains('mx-js'))SKIP+=',.mx';
var MANAGED='.fbl-reveal-item,.fbl-mask,.fbl-process-step,.fbl-hero,.fbl-credential,[data-rv]';
var LEAF=/^(P|H[1-6]|IMG|PICTURE|VIDEO|IFRAME|BLOCKQUOTE|FIGCAPTION|A|BUTTON|LI|DT|DD|LABEL|INPUT|TEXTAREA|SELECT|SUMMARY|TABLE|SPAN|EM|STRONG|SMALL|TIME|ADDRESS|CANVAS)$/;
var INLINE=/^(EM|I|B|STRONG|BR)$/;
var list=[];

/* a white-background photograph set to multiply only blends while nothing
   above it is faded or moved, so those are animated on the image itself */
function blend(el){
  if(el.tagName==='IMG')return false;
  var im=el.getElementsByTagName('img');
  for(var i=0;i<im.length;i++){if(getComputedStyle(im[i]).mixBlendMode!=='normal')return true;}
  return false;
}
function splittable(el){
  if(!/^H[12]$/.test(el.tagName)||!el.textContent.trim())return false;
  var all=el.getElementsByTagName('*');
  for(var i=0;i<all.length;i++){if(!INLINE.test(all[i].tagName))return false;}
  return true;
}
function split(el){
  var i=0;
  (function walk(n){
    [].slice.call(n.childNodes).forEach(function(c){
      if(c.nodeType===3){
        var f=d.createDocumentFragment();
        c.nodeValue.split(/(\s+)/).forEach(function(t){
          if(!t)return;
          if(/^\s+$/.test(t)){f.appendChild(d.createTextNode(' '));return;}
          var s=d.createElement('span');s.className='mxm-w';s.style.setProperty('--i',i++);s.textContent=t;f.appendChild(s);
        });
        n.replaceChild(f,c);
      }else if(c.nodeType===1&&c.tagName!=='BR'){walk(c);}
    });
  })(el);
  el.classList.add('mxm-words');
}
function words(el){split(el);el.classList.add('mxm-wh');el.mxmWords=1;list.push(el);}
function tag(el,fadeOnly){
  el.classList.add('mxm-h');if(fadeOnly)el.classList.add('mxm-f');
  list.push(el);
}
function walk(el){
  var kids=el.children;
  for(var i=0;i<kids.length;i++){
    var c=kids[i];
    if(c.matches(SKIP)||c.hasAttribute('data-rv'))continue;
    var cs=getComputedStyle(c);
    if(cs.display==='none'||cs.visibility==='hidden'||cs.position==='fixed'||+cs.opacity===0)continue;
    if(cs.display==='contents'||c.querySelector(MANAGED)){walk(c);continue;}
    if(splittable(c)){words(c);continue;}
    var h=c.offsetHeight,n=c.children.length,sticky=cs.position==='sticky';
    if(LEAF.test(c.tagName)||!n){
      if(n&&blend(c)){walk(c);continue;}
      tag(c,sticky||h>vh*0.7);continue;
    }
    var row=/flex|grid/.test(cs.display)&&n>1&&h>=160;
    if(h===0||h>vh*0.7||row||blend(c)){walk(c);continue;}
    tag(c,sticky);
  }
}

function next(fn){requestAnimationFrame(function(){requestAnimationFrame(fn);});}
function show(el,k){
  if(el.mxmRv){next(function(){el.classList.remove('mxm-rvw');});return;}
  var delay=Math.min(k,8)*70;
  el.style.setProperty('--mxm-d',delay+'ms');
  if(el.mxmWords){next(function(){el.classList.remove('mxm-wh');});return;}
  el.classList.add('mxm-t');
  next(function(){el.classList.remove('mxm-h','mxm-f');});
  setTimeout(function(){el.classList.remove('mxm-t');el.style.removeProperty('--mxm-d');},delay+1100);
}

try{
  /* fable service pages: headings leave the GSAP fade and take the word reveal.
     Only safe while fable-motion.js has not yet claimed them. */
  if(!window.__fblInit){
    M.querySelectorAll('.fbl-display.fbl-reveal-item').forEach(function(hd){
      if(hd.closest('.fbl-hero')||!splittable(hd))return;
      hd.classList.remove('fbl-reveal-item');
    });
  }
  /* pages with their own [data-rv] reveal: each block now waits until it is
     on screen (their scripts reveal everything after 4.5s regardless), and
     headings play word by word instead of fading as a block */
  M.querySelectorAll('[data-rv]').forEach(function(el){
    if(el.closest(OWN))return;
    if(splittable(el)){el.classList.add('mxm-own');words(el);return;}
    el.querySelectorAll('h1,h2').forEach(function(hd){if(splittable(hd))split(hd);});
    el.classList.add('mxm-rvw');el.mxmRv=1;list.push(el);
  });
  walk(M);
  var io=new IntersectionObserver(function(es){
    var k=0;
    es.forEach(function(e){if(!e.isIntersecting)return;io.unobserve(e.target);show(e.target,k++);});
  },{rootMargin:'0px 0px -8% 0px',threshold:0.05});
  list.forEach(function(el){io.observe(el);});
  done();
}catch(err){
  list.forEach(function(el){el.classList.remove('mxm-h','mxm-f','mxm-wh','mxm-rvw');});
  off();
}
})();
